import React from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.scss";
import DonateWidget from "../../widgets/UI/DonateWidget";
import { IoLogoYoutube, IoLogoInstagram } from "react-icons/io5";
import { FaTelegram, FaRegEnvelope } from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <svg className="footer__defs">
        <defs>
          <linearGradient id="footerIconGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#4facfe" />
            <stop offset="100%" stopColor="#f093fb" />
          </linearGradient>
        </defs>
      </svg>
      <div className="footer__inner">
        <div className="footer__grid">

          <div className="footer__cell">
            <div className="footer__cell-icon-row">
              <FaTelegram className="footer__icon footer__icon--telegram" />
              <img
                className="footer__qrcode"
                src="/images/telegram_chat.png"
                alt="Telegram QR"
              />
            </div>
            <h3 className="footer__cell-title">Тех підтримка та питання</h3>
            <a
              href="https://t.me/+LV2R7SclKzY0ODcy"
              target="_blank"
              rel="noreferrer"
              className="footer__link"
            >
              Telegram група
            </a>
          </div>

          <div className="footer__cell">
            <FaRegEnvelope className="footer__icon footer__icon--email" />
            <h3 className="footer__cell-title">Email</h3>
            <a href="mailto:arynlyrics@gmail.com" className="footer__link">
              arynlyrics@gmail.com
            </a>
          </div>

          <div className="footer__cell">
            <IoLogoYoutube className="footer__icon footer__icon--youtube" />
            <h3 className="footer__cell-title">YouTube</h3>
            <a
              href="https://www.youtube.com/@Aryn-lyrics"
              target="_blank"
              rel="noreferrer"
              className="footer__link"
            >
              Наш канал
            </a>
          </div>

          <div className="footer__cell">
            <IoLogoInstagram className="footer__icon footer__icon--instagram" />
            <h3 className="footer__cell-title">Instagram</h3>
            <a
              href="https://www.instagram.com/aryn_lyrics/"
              target="_blank"
              rel="noreferrer"
              className="footer__link"
            >
              Наш профіль
            </a>
          </div>

        </div>

        <div className="footer__donate">
          <DonateWidget />
        </div>

        <div className="footer__bottom">
          <span
            className="footer__privacy"
            onClick={() => navigate("/privacypolicyukr")}
          >
            Політика конфіденційності сайту
          </span>
          <span className="footer__credits">
            Автори та розробники проекту команда{" "}
            <span className="footer__credits-name">ARYN-devs</span>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
